//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import Requisites from '~/views/TradersRequisitesAndDevices/Requisites/Table.vue';
import Devices from '~/views/TradersRequisitesAndDevices/Devices/Table.vue';

export default {
  components: {
    Requisites,
    Devices,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadRequisites(),
      this.loadDevices(),
      this.loadCurrencies(),
      this.loadPaymentMethods(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('tradersRequisites', {
      loadRequisites: 'loadData',
    }),
    ...mapActions('tradersDevices', {
      loadDevices: 'loadData',
    }),
    ...mapActions('tradersCurrencies', {
      loadCurrencies: 'loadData',
    }),
    ...mapActions('tradersPaymentMethods', {
      loadPaymentMethods: 'loadData',
    }),
  },
};
